export default __webpack_public_path__ + "static/media/icon_2.a6f911e7.svg";